import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ProfileService } from 'src/app/api/profile.service';

@Component({
  selector: 'phone-change-ticket',
  templateUrl: './phone-change-ticket.component.html',
  styleUrls: ['./phone-change-ticket.component.scss']
})
export class PhoneChangeTicketComponent implements OnInit {
  @Input() form: FormGroup;

  constructor(private profileService: ProfileService) { }

  ngOnInit() {
    this.profileService.getGeneral().subscribe(response => {
      this.form.get('phoneChange.oldPhone').setValue(response.phone.censoredPhoneNumber);
    });
  }

  onPassportSelect(file: any) {
    this.form.get('phoneChange.passport').setValue({
      name: file.file.name,
      content: file.base64
    });
  }

  onSelfieSelect(file: any) {
    this.form.get('phoneChange.personalPhoto').setValue({
      name: file.file.name,
      content: file.base64
    });
  }

  onPassportRemove() {
    this.form.get('phoneChange.passport').reset();
  }

  onSelfieRemove() {
    this.form.get('phoneChange.personalPhoto').reset();
  }
}
